import React, { useEffect, useState } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { IonSpinner } from '@ionic/react';
import { useProfileStore } from '../../store/useProfileStore';
import { ClerkUnavailablePage } from './ClerkUnavailablePage';

const CLERK_LOAD_TIMEOUT_MS = 15_000;

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn } = useAuth();
  const { activeProfile } = useProfileStore();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) return;
    const timer = setTimeout(() => setTimedOut(true), CLERK_LOAD_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [isLoaded]);

  if (!isLoaded) {
    if (timedOut) {
      return <ClerkUnavailablePage />;
    }
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <IonSpinner name="crescent" />
      </div>
    );
  }

  if (isSignedIn && !activeProfile) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50 flex-col gap-4">
        <IonSpinner name="crescent" />
        <p className="text-gray-500 text-sm">Loading profile...</p>
      </div>
    );
  }

  return <>{children}</>;
};
